import { FadeUp } from "@/components/FadeUp";
import { COMPANY } from "@/data/site";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page" className="section-y">
      <div className="container-x">
        <FadeUp>
          <p className="eyebrow">About MIM Engineering</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-primary mt-4 leading-[0.95] max-w-4xl">
            A Bayswater workshop built on <span className="italic text-secondary">precision</span>, trust, and turnaround.
          </h1>
        </FadeUp>

        <div className="mt-20 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start" data-testid="about-company-story">
          <div className="lg:col-span-7">
            <div className="image-hover aspect-[4/3] overflow-hidden">
              <img
                src="/uploads/mim-shaft-rebuild-2.jpg"
                alt="MIM Engineering workshop floor"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:col-span-5 lg:pt-10" data-testid="about-mission">
            <p className="eyebrow">Our Story</p>
            <h2 className="font-serif text-3xl md:text-4xl text-primary mt-3 leading-tight">
              We exist to keep critical equipment in service.
            </h2>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
              MIM Engineering is a local, family-minded workshop serving Western Australian industry from
              {" "}{COMPANY.address}. We combine modern CNC machining with experienced manual tradecraft to deliver
              complete solutions — machined, fabricated, coated and assembled.
            </p>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
              Our clients lean on us because we pick up the phone, respond to breakdowns, hold tolerances,
              and don&apos;t sign off work until it&apos;s right.
            </p>
          </div>
        </div>

        <div className="mt-28 grid md:grid-cols-3 gap-10">
          {[
            { num: "01", title: "Safety First", desc: "Safety is the priority across every job, every shift." },
            { num: "02", title: "Quality Assured", desc: "Calibrated instruments. Documented inspection. No shortcuts." },
            { num: "03", title: "End-to-End", desc: "Machine, fabricate, coat, assemble — all under one roof." },
          ].map((p, i) => (
            <FadeUp key={p.num} delay={i * 0.08} className="border-t border-primary pt-6">
              <span className="editorial-number text-3xl text-accent">{p.num}</span>
              <h3 className="font-serif text-3xl text-primary mt-3">{p.title}</h3>
              <p className="mt-3 text-muted-foreground">{p.desc}</p>
            </FadeUp>
          ))}
        </div>

        <div className="mt-28 flex items-center gap-6 flex-wrap">
          <Link to="/quote" className="inline-flex items-center gap-2 px-6 py-3.5 bg-primary text-primary-foreground uppercase tracking-[0.18em] text-xs hover:bg-accent transition-colors">
            Start a Project
          </Link>
          <Link to="/machine-capacity" className="text-sm uppercase tracking-wider link-underline">View machine capacity →</Link>
        </div>
      </div>
    </div>
  );
}
